module.exports = __webpack_public_path__ + "img/typhoon_50.85b9d75f.jpg";